/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type LanguageCode = typeof LanguageCode[keyof typeof LanguageCode];


export const LanguageCode = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_5: 5,
  NUMBER_15: 15,
  NUMBER_16: 16,
} as const;
